import { MenuItem, TextField, TextFieldProps } from '@mui/material';

export const BooleanDropdown: React.FC<
  Omit<TextFieldProps, 'select' | 'value' | 'onChange' | 'children'> & {
    value: boolean | null;
    onChange: (value: boolean | null) => void;
  }
> = props => {
  return (
    <TextField
      {...props}
      value={props.value === null ? '' : props.value ? 'true' : 'false'}
      onChange={e => {
        if (e.target.value === '') {
          props.onChange(null);
        } else {
          props.onChange(e.target.value === 'true');
        }
      }}
      select
    >
      <MenuItem value="">
        <em>None</em>
      </MenuItem>
      <MenuItem value={'true'}>Yes</MenuItem>
      <MenuItem value={'false'}>No</MenuItem>
    </TextField>
  );
};
